module.exports = __webpack_public_path__ + "static/media/news-img02.cb347884.jpg";